import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	refinementOptionCurrentUser: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-current-user',
		defaultMessage: 'Current User',
		description: 'Current User option in issue navigator refinement dropdown.',
	},
	refinementOptionUnassigned: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-unassigned',
		defaultMessage: 'Unassigned',
		description: 'Unassigned option in issue navigator refinement dropdown.',
	},
	refinementOptionSuggestedUsers: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-users',
		defaultMessage: 'Suggested Users',
		description: 'Suggested Users subtitle in issue navigator refinement dropdown',
	},
	refinementOptionSuggestedGroups: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-groups',
		defaultMessage: 'Suggested Groups',
		description: 'Suggested Groups subtitle in issue navigator refinement dropdown',
	},
});
